import React, {useEffect, useState} from 'react';
import 'typeface-roboto';
import './main.css';
import MenuAppBar from './components/MenuAppBar';
import PageController from './pages/PageController';
import 'react-virtualized/styles.css';
import {useDispatch, useSelector} from "react-redux";
import {setClient, setListOfPatients, START_PHONE_SEND} from "@cabinet-packages/redux";
import {useAppState} from "@cabinet-packages/hooks";
import {MuiThemeProvider} from "@material-ui/core";
import themeMaterialUI from "./settings/themeMaterialUI";
import logo from '../src/assets/images/logo.svg';
import routes from "./settings/routes";
import LogoutDialog from './components/LogoutDialog';
import {logout} from "@cabinet-packages/api";
import {AccessKey} from "@cabinet-packages/helpers";

function LandingPage() {
    const  dispatch = useDispatch();
    const { client } = useAppState();
    const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
    const [historyRef, setHistoryRef] = useState(null);
    const [setHistoryPushRef, setSetHistoryPushRef] = useState(null);

    const {activePatient, listOfPatients} = useSelector(state => state.patients);
    useEffect(() => {
        if (client && (!activePatient || !listOfPatients)) {
            dispatch(setClient(client));
            dispatch(setListOfPatients(false, true));
        }
    }, [client, activePatient, dispatch, listOfPatients]);

    const handleLogoutClick = (event, history, dispatch, setHistoryPushWhenLogOut) => {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        setHistoryRef(history);
        setSetHistoryPushRef(() => setHistoryPushWhenLogOut);
        setLogoutDialogOpen(true);
    };

    const handleLogoutConfirm = async () => {
        try {
            logout();
        } catch (e) {
            console.error(e);
        }
        localStorage.removeItem('activePatient');
        localStorage.removeItem('accessKey');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('activePatientPhone');
        localStorage.removeItem('uuid');
        AccessKey.remove();
        dispatch(setClient(null));
        dispatch({
            type: START_PHONE_SEND,
            payload: {
                stage: 1,
            },
        });
        if (setHistoryPushRef) {
            setHistoryPushRef(true);
        } else if (historyRef) {
            historyRef.push('/');
        }
    };

    return (<div className="App">
        <MenuAppBar
            logo={logo}
            themeMaterialUI={themeMaterialUI}
            routes={routes}
            isReturnToShop={true}
            onLogoutClick={handleLogoutClick}
        />
        <MuiThemeProvider theme={themeMaterialUI}>
            <PageController/>
        </MuiThemeProvider>
        <LogoutDialog
            open={logoutDialogOpen}
            onClose={() => setLogoutDialogOpen(false)}
            onConfirm={handleLogoutConfirm}
        />
    </div>);
}

export default LandingPage;
